export const fromGqlCollection = (gqlCollection) => gqlCollection.reduce((acc, item) => (Object.assign(Object.assign({}, acc), { [item.feature]: item.enabled })), {});
//# sourceMappingURL=CheckoutFeatures.js.map